// Mock data for Russian Education — MBBS in Russia consultancy site.

export const marqueeItems = [
  { icon: 'FileEdit', text: 'Apply Now for 2025–26 Admissions' },
  { icon: 'Phone', text: 'Call Now: +91 95094 06802' },
  { icon: 'MessageCircle', text: 'WhatsApp for Free Counselling' },
  { icon: 'GraduationCap', text: 'WHO Recognised Universities' },
  { icon: 'Plane', text: '100% Visa Success Rate' },
  { icon: 'Building2', text: '50+ Partner Universities in Russia' },
];

export const navLinks = [
  { label: 'Home', href: '#home' },
  { label: 'MBBS in Russia', href: '#mbbs' },
  { label: 'Universities', href: '#universities' },
  { label: 'Counsellors', href: '#counsellors' },
  { label: 'Alumni', href: '#alumni' },
  { label: 'Services', href: '#services' },
  { label: 'Contact', href: '#contact' },
];

export const stats = [
  { value: '1500+', label: 'Students Placed' },
  { value: '25+', label: 'Partner Universities' },
  { value: '10+', label: 'Years Experience' },
  { value: '100%', label: 'Visa Success' },
];

export const advantages = [
  {
    title: 'WHO Recognized',
    subtitle: 'Globally Valid Degree',
    highlight: '195+',
    highlightLabel: 'Countries Accept',
    icon: 'ShieldCheck',
    points: ['NMC / MCI Approved', 'Valid in UK, USA, Canada', 'Eligible for USMLE, PLAB'],
  },
  {
    title: 'Affordable Fees',
    subtitle: 'Govt. Subsidized Cost',
    highlight: '₹25L',
    highlightLabel: 'Total 6-Year Cost',
    icon: 'Wallet',
    points: ['No hidden charges', '₹3–5L/year tuition', 'Cheaper than Indian pvt. colleges'],
  },
  {
    title: 'No Donation',
    subtitle: 'Pure Merit Admission',
    highlight: '0',
    highlightLabel: 'Capitation Fee',
    icon: 'BadgeCheck',
    points: ['NEET-based admission', 'Direct university seats', 'No middlemen markup'],
  },
  {
    title: 'English Medium',
    subtitle: 'Full English Program',
    highlight: '6',
    highlightLabel: 'Years in English',
    icon: 'Languages',
    points: ['No language barrier', 'Qualified English faculty', 'FMGE/NExT coaching included'],
  },
];

// Re-export the comprehensive universities dataset (64 universities)
export { universities, getUniversityBySlug, fmtRub, inrApprox } from './universities';
import { universities as _unis } from './universities';

// Partner logos short-codes (auto-generated from all 64 unis)
export const partnerLogos = _unis.map((u) => u.short);

export const counsellors = [
  { initials: 'PS', name: 'Dr. Pradeep Sharma', years: 12, students: '1,400+', reviews: 312, city: 'Chandigarh', state: 'Punjab', rating: 4.9, tags: ['Honest', 'Thorough', 'FMGE Focused'] },
  { initials: 'KN', name: 'Ms. Kavya Nair', years: 8, students: '950+', reviews: 218, city: 'Kochi', state: 'Kerala', rating: 4.8, tags: ['Supportive', 'Detail-oriented', 'South India Specialist'] },
  { initials: 'RV', name: 'Mr. Rahul Verma', years: 10, students: '1,200+', reviews: 278, city: 'Patna', state: 'Bihar', rating: 4.9, tags: ['Strategic', 'Budget Savvy', 'Scholarship Expert'] },
  { initials: 'SK', name: 'Dr. Sneha Kulkarni', years: 9, students: '870+', reviews: 195, city: 'Pune', state: 'Maharashtra', rating: 4.7, tags: ['Transparent', 'Parent Friendly', 'Fee Planner'] },
  { initials: 'AK', name: 'Mr. Arun Krishnamurthy', years: 7, students: '730+', reviews: 164, city: 'Chennai', state: 'Tamil Nadu', rating: 4.8, tags: ['Safety Focused', 'Post-Arrival Support', 'Optimistic'] },
  { initials: 'PA', name: 'Ms. Pooja Agarwal', years: 6, students: '620+', reviews: 147, city: 'Jaipur', state: 'Rajasthan', rating: 4.9, tags: ['Confidence Builder', 'Unbiased', 'FMGE Connect'] },
];

export const alumniInitials = [
  ['DM', 'SN', 'AT', 'MK'],
  ['RS', 'VG', 'SP', 'PR'],
  ['PV', 'MM', 'NJ', 'AS'],
  ['AK', 'KR', 'RB', 'DS'],
];

export const testimonials = [
  { initials: 'PS', name: 'Priya Sharma', quote: 'Russian Education made the entire process seamless. From document apostille to airport pickup in Kazan — everything was handled. The English-medium teaching here is world-class and I feel fully prepared for FMGE.', year: '3rd Year MBBS', uni: 'Kazan Federal University', state: 'Rajasthan' },
  { initials: 'AV', name: 'Arjun Verma', quote: "I was nervous about moving abroad but Russian Education's local team in Kursk was always available. Indian food is available here, seniors are very helpful, and hostel facilities are great. Best decision of my life!", year: '2nd Year MBBS', uni: 'Kursk State Medical University', state: 'Uttar Pradesh' },
  { initials: 'SP', name: 'Sneha Patel', quote: "The fee transparency was what made me choose Russian Education. No hidden charges, no last-minute surprises. Volgograd is beautiful and safe. I'm now preparing for FMGE and Russian Education connected me with a great coaching institute.", year: '4th Year MBBS', uni: 'Volgograd State Medical University', state: 'Gujarat' },
  { initials: 'RS', name: 'Rohit Singh', quote: 'As a first-generation MBBS student in my family, my parents were very concerned. Russian Education counselors patiently answered every question at every hour. The onboarding in Ufa was amazing — I felt welcomed from day one.', year: '1st Year MBBS', uni: 'Bashkir State Medical University', state: 'Bihar' },
  { initials: 'AR', name: 'Ananya Reddy', quote: "5 years in Rostov and I have zero regrets. The city is warm (weather and people!), Indian community is huge, and the medical education quality is genuinely excellent. Russian Education's local rep here has been a lifesaver more than once.", year: '5th Year MBBS', uni: 'Rostov State Medical University', state: 'Andhra Pradesh' },
  { initials: 'KM', name: 'Karan Mehta', quote: 'Saint Petersburg is stunning and studying medicine here feels surreal. Russian Education got me the admission letter within 10 days and the visa in 3 weeks. Their WhatsApp support is truly 24/7 — I texted at 2 AM once and got a reply!', year: '2nd Year MBBS', uni: 'Saint Petersburg State University', state: 'Maharashtra' },
];

export const trustedVoices = [
  { views: '4.3K', quote: 'Got admission in 15 days', name: 'Rahul Gupta', year: '1st Year', city: 'Kazan', state: 'Delhi' },
  { views: '19.4K', quote: 'Counselling helped shape my future', name: 'Mahak Kashyap', year: '3rd Year', city: 'Kursk', state: 'Punjab' },
  { views: '9.7K', quote: 'No hidden fees, no surprises', name: 'Priyanka Nair', year: '2nd Year', city: 'Volgograd', state: 'Kerala' },
  { views: '6K', quote: 'Took admission without any hassle', name: 'Sneha Singh', year: '4th Year', city: 'Rostov', state: 'UP' },
  { views: '7.2K', quote: 'Best decision of my medical career', name: 'Amit Verma', year: '5th Year', city: 'Bashkir', state: 'Bihar' },
  { views: '11.8K', quote: 'FMGE cleared on first attempt', name: 'Pooja Sharma', year: 'Completed', city: 'Moscow', state: 'Rajasthan' },
];

export const faqs = [
  { q: 'What is the cost of MBBS in Russia for Indian students?', a: 'The total cost of MBBS in Russia for Indian students ranges between ₹20–25 lakhs for the full 6-year program. This includes tuition, hostel, and living expenses — significantly cheaper than private medical colleges in India.' },
  { q: 'Is MBBS from Russia valid in India?', a: 'Yes. MBBS degrees from Russian government universities are recognized by the National Medical Commission (NMC/MCI) of India. Students need to clear the FMGE / NExT after returning to India to practice.' },
  { q: 'Is NEET required for MBBS admission in Russia?', a: 'Yes, NEET qualification is mandatory for Indian students seeking MBBS admission in Russia as per NMC guidelines since 2019.' },
  { q: 'What is the duration of MBBS in Russia?', a: 'MBBS in Russia is a 6-year program, including 5 years of academic coursework and 1 year of clinical internship at university-affiliated hospitals.' },
  { q: 'Can Indian students study MBBS in Russia in English?', a: 'Yes, most Russian government medical universities offer the entire MBBS program in English. Russian language is taught as a subject to help students during clinical rotations.' },
  { q: 'What is the process to apply for MBBS in Russia through Russian Education?', a: 'The process includes free counselling, university selection, document preparation, application submission, invitation letter, visa processing, travel arrangements, and post-arrival support — all handled end-to-end by Russian Education.' },
  { q: 'Are Russian medical universities recognized by WHO?', a: 'Yes, all universities we partner with are recognized by the World Health Organization (WHO), NMC (India), UNESCO, and are listed in the World Directory of Medical Schools (WDOMS).' },
  { q: 'What is the age limit for MBBS in Russia?', a: 'Students must be at least 17 years old by December 31st of the admission year. There is no strict upper age limit, but a valid NEET score is required.' },
];
